(function () {



const $20c5c1843a87be9e$var$WINDOW_CHANGE_EVENT = 'onorientationchange' in window ? 'orientationchange' : 'resize';
document.querySelectorAll('.pure-toggle-menu').forEach((menu)=>{
    const toggle = menu.querySelector('.toggle');
    if (toggle == null) {
        console.warn("'.pure-toggle-menu' without '.toggle'");
        return;
    }
    const toggleMenu = ()=>{
        menu.classList.toggle('closed');
        toggle.classList.toggle('x');
    };
    toggle.addEventListener('click', (e)=>{
        e.preventDefault();
        toggleMenu();
    });
    window.addEventListener($20c5c1843a87be9e$var$WINDOW_CHANGE_EVENT, ()=>{
        if (menu.classList.contains('closed')) return;
        toggleMenu();
    });
});




})();
//# sourceMappingURL=Default.45b6b656.js.map
